export default __webpack_public_path__ + "static/tablet_KV14-9f1489ebeae33dd81b451431dce2ee08.mp4";